import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import "./RightPanel.css";

const RightPanel = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  width = "500px",
  overlayZIndex = 50,
}) => {
  const panelZIndex = overlayZIndex + 1;
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  return (
    <>
      {/* Backdrop */}
      <div 
        className={`right-panel-backdrop ${isOpen ? "open" : ""}`}
        style={{ zIndex: overlayZIndex }}
        onClick={onClose}
      />
      
      {/* Panel */}
      <div 
        className={`right-panel ${isOpen ? "open" : ""}`}
        style={{ width, zIndex: panelZIndex }}
      >
        {/* Header */}
        <div className="right-panel-header">
          <button 
            className="right-panel-close"
            onClick={onClose}
            aria-label="Close panel"
          >
            <FaTimes size={20} />
          </button>
          {title && <h2 className="right-panel-title">{title}</h2>}
        </div>
        
        {/* Content */}
        <div className="right-panel-content">
          {children}
        </div>
      </div>
    </>
  );
};

export default RightPanel;